import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BusComponent from '../BusComponent';

import { endTourButtonEvents } from '../../enums/GoogleTagManagerEvents';
import googleTagManagerEvents from '../../helpers/GoogleTagManagerEventsWrapper';

const EndTourButton = googleTagManagerEvents('button', endTourButtonEvents);

class HelpTourStep extends BusComponent {
    constructor(props, context) {
        super(props, context);
    }

    onClose = () => {
        this.props.onClose();
    };

    onPreviousStep = () => {
        this.props.onPrevious();
    };

    onNextStep = () => {
        this.props.onNext();
    };

    onSelectedStep = stepId => {
        this.props.onSelected(stepId);
    };

    renderStepHeader() {
        const { title } = this.props.options;
        return (
            <div className="flex-it flex-start row margin-bottom-15 space-between step-header">
                <h2 className="font-bold-6">{title}</h2>
                <button className="clickable padded-horizontal-4" onClick={this.onClose}>
                    <i className="material-icons">close</i>
                </button>
            </div>
        );
    }

    renderStepNavigation() {
        const buttonClasses = classNames('flex-it center clickable font-bold-6');
        const { previousStepId, nextStepId, id } = this.props.options;
        const isFirstStep = !previousStepId;
        const isLastStep = !nextStepId;

        const previousButtonClasses = classNames(buttonClasses, {
            hidden: isFirstStep,
        });

        const previousButton = (
            <button
                className={previousButtonClasses}
                onClick={this.onPreviousStep}
                aria-label="Previous step"
            >
                <i className="material-icons">keyboard_arrow_left</i>
                BACK
            </button>
        );

        let nextButton = (
            <button className={buttonClasses} onClick={this.onNextStep} aria-label="Next step">
                NEXT
                <i className="material-icons">keyboard_arrow_right</i>
            </button>
        );

        if (isLastStep) {
            nextButton = (
                <EndTourButton className={buttonClasses} onClick={this.onClose}>
                    OKAY, GOT IT!
                </EndTourButton>
            );
        }

        const stepButtons = [];
        const stepIds = Object.keys(this.props.tourSteps);
        for (let i = 0; i < stepIds.length; i += 1) {
            const stepClasses = classNames('circle clickable', {
                selected: stepIds[i] === id,
            });
            stepButtons.push(
                <div
                    key={i}
                    className={stepClasses}
                    onClick={() => this.onSelectedStep(stepIds[i])}
                />,
            );
        }

        return (
            <div className="flex-it space-between step-footer">
                <div className="flex-it control">{previousButton}</div>
                <div className="flex-it row center indicator">{stepButtons}</div>
                <div className="flex-it control">{nextButton}</div>
            </div>
        );
    }

    render() {
        const { classes, content, id } = this.props.options;
        const stepClasses = classNames('flex-it column help-tour-step', classes);

        const renderedContent = React.isValidElement(content)
            ? React.cloneElement(content, { bus: this.props.bus, stepId: id })
            : content;

        return (
            <div className={stepClasses} ref={this.props.helpTourRef}>
                {this.renderStepHeader()}
                {renderedContent}
                {this.renderStepNavigation()}
            </div>
        );
    }
}

HelpTourStep.propTypes = {
    options: PropTypes.object.isRequired,
    tourSteps: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onPrevious: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onSelected: PropTypes.func.isRequired,
    helpTourRef: PropTypes.func,
    bus: PropTypes.object.isRequired,
};

HelpTourStep.defaultProps = {
    helpTourRef: undefined,
};

export default HelpTourStep;
